<div class="confirmation-page">
  <ng-container *ngIf="isItTransaction && isPositionsTransaction(); then displayMulitpleTransfers; else displaySingleTransfer;"></ng-container>
  <ng-template #displayMulitpleTransfers>
    <div class="container">
      <positions-table-multiple-to-account
        [reviewConfirmationPage]="true"
        [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
      ></positions-table-multiple-to-account>
      <div
        class="print-content"
        id="print-confirmation-page"
      >
        <img
          id="print-logo"
          src="./static/assets/images/cs_logo-04.png"
          width="100"
          height="100"
        >
        <span
          id="confirmation-page-header"
          class="section-title"
        >Confirmation</span>
        <mm-banners
          class="hideSection"
          *ngIf="this.getOverAllErrorStatus()"
          [type]="'error'"
          [bannerText]="[errorBannerTextPhase2]"
          data-testid="submit-create-error-banner"
        ></mm-banners>
        <sdps-tabs
          sdps-id="folder-tabs-example"
          id="to-account-tabs"
          (click)=preventDefault($event)
          is-folder
        >
          <sdps-tab-bar
            class="hideSection tabs-bar-scroll"
            slot="bar"
            (click)=preventDefault($event)
            scrollable
          >
            <div *ngFor="let toAccount of toAccounts; index as i">
              <sdps-tab-button
                [attr.sdps-id]="toAccount"
                [attr.selected]="i === 0 ? true : null"
              >
                <a [ngClass]="!this.getErrorStatus(toAccount) ? ['confirmTabIcon', 'no-icon'] : ['confirmTabIcon', 'tab-error-icon']"></a>
                <span> {{toAccount}} </span>
              </sdps-tab-button>
            </div>
          </sdps-tab-bar>
          <div *ngFor="let toAccount of toAccounts; index as i">
            <sdps-tab-panel
              [attr.sdps-id]="toAccount"
              [attr.selected]="i === 0 ? true : null"
            >
              <div class="download-link-container hideSection">
                <a
                  (click)="downloadPdf()"
                  id="download-pdf-link-multiple-lot-selections"
                ><i class="sch-download"></i>Confirmation summary</a>
              </div>
              <div class="receiving-account-summary-header">Receiving account confirmation summary:
                <div
                  class="download-link-container hideSection"
                  data-testid="download_link"
                  *ngIf="showAuthorizationFormLink"
                >
                  <a
                    (click)="onViewMultiAuthFormClicked(toAccount)"
                    id="download-multi_auth-form-link"
                  ><i class="sch-download"></i>Authorization form</a>
                </div>
              </div>
              <div class="receiving-account-summary-sub-header">{{toAccount}} {{toAccountInContextName}}</div>
              <br>
              <div
                id="error-message"
                *ngIf="this.getGenericServiceError(toAccount)"
              >
                <div
                  id="error-icon"
                  class="error-icon"
                ></div>
                <span id="error-text"> {{this.getGenericServiceError(toAccount)}} </span>
              </div>
              <div
                *ngIf="getEauthSuccessMessage() && !getLoaNeededMessage() && !this.getErrorStatus(toAccount)"
                id="success"
              >
                <div
                  id="success-icon"
                  class="success-icon"
                ></div>
                <span id="success-text"> {{getEauthSuccessMessage()}} </span>
              </div>
              <div
                *ngIf="getLoaNeededMessage() && !this.getErrorStatus(toAccount) && this.eAuthInfo?.isOptedOut"
                id="warning"
              >
                <div
                  id="warning-icon"
                  class="warning-icon"
                ></div>
                <span id="warning-text"> {{requiringClientAuthorizationWarningText}} </span>
              </div>
              <div
                *ngIf="this.showIandRmessageMultipleFlow(toAccount)"
                id="warning"
                data-testid="initiator-confirm-message"
              >
                <div
                  id="warning-icon"
                  class="warning-icon"
                ></div>
                <span id="warning-text"> {{initiatorConfirmMessage}} </span>
              </div>
              <div
                *ngIf="isItOneTimeTotalDist || is401kToAccount"
                id="warning"
                data-testid="total-dist-it-warning-message"
              >
                <div
                  id="warning-icon"
                  class="warning-icon"
                ></div>
                <span id="warning-text"> {{itDocusignWarningMessage()}} </span>
              </div>
              <br>
              <mm-confirmation-details-section
                [toAccountInContext]="toAccount"
                [draftInContext]="isInitiateAndReleaseFlowFromTable"
                [journalAuthResponse]="this.itsInfo.journalAuthResponse[toAccount.replace('-', '')]"
              ></mm-confirmation-details-section>
              <div
                class="top-buttons hideSection"
                id="button-container"
              >
                <button
                  id="confirmationPage_viewTransactionStatusButton"
                  *ngIf="!this.transactionFailedStatus && !this.getErrorStatus(toAccount) && !isOneTimeTotalDist && !is401kToAccount"
                  type="button"
                  (click)="onViewTransactionStatusClickedMultipleToAccount(toAccount)"
                  class="sdps-button sdps-button--small sdps-button--secondary"
                >{{this.getViewButtontextMultipleFlow(toAccount)}}</button>
                <button
                  *ngIf="!canRelease || (canRelease && !isInitiateAndReleaseFlowFromTable)"
                  id="confirmationPage_createAnotherRequestButton"
                  type="button"
                  (click)="onCreateAnotherRequestClicked()"
                  class="sdps-button sdps-button--small sdps-button--secondary"
                > {{getCreateTransactionButtonText(toAccount)}}</button>
              </div>
              <sdps-divider
                class="divider"
                variation="secondary"
              ></sdps-divider>
              <mm-account-details-section></mm-account-details-section>
              <mm-multiple-transaction-details-section-it
                [confirmationPagePhase2]="true"
                [toAccountInContextDetails]="toAccountInContextDetails"
                [transactionDetailsInContext]="transactionDetailsInContext"
                [toAccountPTRSInfoInContext]="toAccountPTRSInfoInContext"
                [displayToAccPTRSFields]="displayToAccPTRSFields"
                [isCashAvailableInContext]="isCashAvailableInContext"
                [zeroFedAndStateTax]="zeroFedAndStateTax"
                [fedTaxPercent]="fedTaxPercent"
                [isInrFromTable]="isInitiateAndReleaseFlowFromTable"
              ></mm-multiple-transaction-details-section-it>
              <span id="subtitle">Transfer totals</span>
              <div class="table-container">
                <div class="table-row small-padding">
                  <span
                    *ngIf="TotalValues || isOneTimeTotalDist"
                    class="table-est-mkt-value-column table-header"
                  >Est mkt val. of positions</span>
                  <span
                    *ngIf="(TotalValues && showTransferTotalsCash) || isOneTimeTotalDist"
                    [ngClass]="{'table-total-msg-column': isOneTimeTotalDist, 'table-header': true, 'table-monetary-value-column': !isOneTimeTotalDist}"
                  >Cash to receive</span>
                  <span
                    *ngIf="(TotalValues && showTransferTotalsCash) || isOneTimeTotalDist"
                    [ngClass]="{'table-total-msg-column': isOneTimeTotalDist, 'table-header': true, 'table-monetary-value-column': !isOneTimeTotalDist}"
                  >Est total to receive</span>
                  <span
                    *ngIf="isInitiator && this.transferType != 'positions' && !isOneTimeTotalDist"
                    [ngClass]="{'total-to-receive-column text-align-right': isOneTimeTotalDist, 'table-header': true, 'table-monetary-value-column': !isOneTimeTotalDist}"
                  >Total to receive</span>
                </div>
                <div class="break extra-small-padding"></div>
                <div
                  *ngIf="!isOneTimeTotalDist"
                  data-testid="transfer-total-section"
                >
                  <div
                    *ngIf="TotalValues"
                    class="table-est-mkt-value-column"
                    data-testid="position-total-value"
                  >{{TotalValues.positionTotatValue}}</div>
                  <div
                    *ngIf="TotalValues && showTransferTotalsCash"
                    class="table-monetary-value-column"
                    data-testid="cash-total-value"
                  >{{TotalValues.cashTotalValue}}</div>
                  <div
                    *ngIf="TotalValues && showTransferTotalsCash"
                    class="table-monetary-value-column"
                    data-testid="est-total-to-receive"
                  >{{sumTotals([TotalValues.positionTotatValue, TotalValues.cashTotalValue])}}</div>
                  <div
                    *ngIf="isInitiator && this.transferType != 'positions'"
                    class="total-to-receive-column"
                  >{{totalToReceiveVerbiage}}</div>
                </div>
                <div
                  *ngIf="isOneTimeTotalDist"
                  data-testid="total-dist-transfer-total-section"
                >
                  <div class="table-est-mkt-value-column">{{emvTotalDist}}</div>
                  <div
                    *ngIf="showTransferTotalsCash"
                    class="table-total-msg-column"
                  >Total cash balance will be distributed</div>
                  <div
                    *ngIf="showTransferTotalsCash"
                    class="table-total-msg-column"
                  > Total account balance will be distributed </div>
                </div>
              </div>
              <br>
              <sdps-divider
                class="divider"
                variation="secondary"
                *ngIf="isItOneTimeTotalDist"
              ></sdps-divider>
            </sdps-tab-panel>
          </div>
          <div>
            <mm-client-auth-details-section
              *ngIf="showClientAuthorizationDetails && !isFirstPartyAccounts() && !isItTransaction"
              [eAuthInfo$]="eAuthInfo$"
              [eAuthCustomers$]="eAuthCustomers$"
            ></mm-client-auth-details-section>
          </div>
        </sdps-tabs>
      </div>
    </div>
  </ng-template>
  <ng-template #displaySingleTransfer>
    <div class="container">
      <div class="download-link-container">
        <a
          *ngIf="showAuthFormLink"
          (click)="onViewAuthFormClicked()"
          data-testid="show-Auth-form-Link"
          id="download-auth-form-link"
        ><i class="sch-download"></i>Authorization form</a>
        <a
          (click)="downloadPdf()"
          id="download-pdf-link"
        ><i class="sch-download"></i>Confirmation summary</a>
      </div>
      <div
        class="print-content"
        id="print-confirmation-page"
      >
        <img
          id="print-logo"
          src="./static/assets/images/cs_logo-04.png"
          width="100"
          height="100"
        >
        <span
          id="confirmation-page-header"
          class="section-title"
        >Confirmation</span>
        <div *ngIf="((isPending$ | async) || isInRFirm) && !((submitAndCreateStatus$ | async)?.hasError) && !isChecksBundledOneTimeTotalDist && !isChecksOneTimeTotalDist && !customRuleIandRFlowOff">
          <mm-confirm-pend-reason
            data-testid="pend-reason"
            [pendReasonDescription]="pendReasonDescription$ | async"
            [useIcon]="pendReasonIcon$ | async"
          ></mm-confirm-pend-reason>
        </div>
        <div *ngIf="transactionType === 'ach' && !isInRFirm">
          <mm-ach-confirm-message
            [isNewRecurringProfile]="isCreateRecurringAchProfile"
            [isNewOnRequestProfile]="isCreateOnRequestAchProfile"
          ></mm-ach-confirm-message>
        </div>
        <div
          id="warning"
          *ngIf="displayAllianceWarning"
        >
          <div
            id="warning-icon"
            data-testid="warning-icon"
            class="warning-icon"
          ></div>
          <span
            *ngIf="!(isOneTimeTotalDist || isChecksBundledOneTimeTotalDist)"
            id="warning-text"
          >{{sendAllianceInstructionsWarningText}}</span>
          <span
            *ngIf="(isOneTimeTotalDist || isChecksBundledOneTimeTotalDist)"
            id="warning-text"
          >{{oneTimeTotalDistWarningMessage}}</span>
        </div>
        <div *ngIf="showI401kOrTotalDistWarning" id="i401k-warning">
          <div id="warning-icon" class="warning-icon"></div>
          <span id="warning-text">{{itDocusignWarningMessage()}}</span>
        </div>
        <mm-banners
          *ngIf="(submitAndCreateStatus$ | async)?.hasError"
          [type]="'error'"
          [bannerText]="[submitAndCreateBannerText]"
          data-testid="submit-create-error-banner"
        ></mm-banners>
        <mm-confirmation-details-section [useCondensedLayout]="!useOriginalLayout" [draftInContext]="isInitiateAndReleaseFlowFromTable"></mm-confirmation-details-section>
        <div
          class="top-buttons hideSection"
          id="button-container"
        >
          <button *ngIf="!isOneTimeTotalDist && !isCondensedWireCreatePdfFlow"
            id="confirmationPage_viewTransactionStatusButton"
            type="button"
            (click)="onViewTransactionStatusClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary"
          >{{viewButtonText}}</button>
          <button
            *ngIf="!canRelease || (canRelease && !isInitiateAndReleaseFlowFromTable)"
            id="confirmationPage_createAnotherRequestButton"
            type="button"
            (click)="onCreateAnotherRequestClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary"
          >{{createTransactionButtonText}}</button>
          <button
            *ngIf="showSaveAsTemplate && !isInitiateAndReleaseFlowFromTable"
            id="confirmationPage_saveAsTemplate"
            data-testid="confirmationPage_saveAsTemplate"
            type="button"
            (click)="onSaveAsTemplateClicked()"
            class="sdps-button sdps-button--small sdps-button--secondary"
          >Save this as a template</button>
        </div>
        <sdps-divider
          [ngClass]="useOriginalLayout ? 'divider' : 'condensed-divider'"
          variation="secondary"
        ></sdps-divider>
        <mm-transaction-review-ach
          *ngIf="isAchTransaction"
          data-testid="transaction-review-ach-component"
        ></mm-transaction-review-ach>
        <mm-transaction-review-check
          *ngIf="isCheckTransaction" [isInitiateAndReleaseFlowFromTable]="isInitiateAndReleaseFlowFromTable"
          data-testid="transaction-confirmation-check-component"
        ></mm-transaction-review-check>
        <mm-transaction-review-it
          *ngIf="isItTransaction"
          data-testid="transaction-confirmation-it-component"
        ></mm-transaction-review-it>
        <mm-transaction-review
          *ngIf="useOriginalLayout && !isItTransaction"
          data-testid="transaction-confirmation-original-layout"
        ></mm-transaction-review>
        <mm-transaction-review-wire
          *ngIf="isWireTransaction() && !useOriginalLayout"
          data-testid="transaction-confirmation-wire-component"
        ></mm-transaction-review-wire>
        <mm-transmission-notes 
            *ngIf="isWireTransaction() && !useOriginalLayout && !!transmissionNotes" 
            [transmissionNotes]="transmissionNotes" 
            [transmissionNotesLabel]="transmissionNotesLabel" 
            data-testid="transmission-notes">
        </mm-transmission-notes>
        <sdps-divider
          class="condensed-divider-line"
          *ngIf="!useOriginalLayout && eAuthInfo?.isOptedOut && showClientAuthorizationDetails && !(isChecksOneTimeTotalDist || isChecksBundledOneTimeTotalDist) && !isItTransaction"
          variation="secondary"
        ></sdps-divider>
        <mm-client-auth-details-section
          *ngIf="showClientAuthorizationDetails && ShowClientDetailsEauthOptout && !(isChecksOneTimeTotalDist || isChecksBundledOneTimeTotalDist) && !isItTransaction"
          [eAuthInfo$]="eAuthInfo$"
          [eAuthCustomers$]="eAuthCustomers$"
          [useCondensedLayout]="!useOriginalLayout"
        ></mm-client-auth-details-section>
        <mm-condensed-eauth-section *ngIf="showClientAuthorizationDetails && !ShowClientDetailsEauthOptout && !(isChecksOneTimeTotalDist || isChecksBundledOneTimeTotalDist) && !isItTransaction"></mm-condensed-eauth-section>
      </div>
      <div
        *ngIf="isChecksOneTimeTotalDist || isChecksBundledOneTimeTotalDist"
        id="button-container"
      >
        <button *ngIf="!isOneTimeTotalDist"
          id="confirmationPage_viewTransactionStatusButton"
          type="button"
          (click)="onViewTransactionStatusClicked()"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >{{viewButtonText}}</button>
        <button
          *ngIf="(!canRelease || (canRelease && !isInitiateAndReleaseFlowFromTable)) || isChecksOneTimeTotalDist || isChecksBundledOneTimeTotalDist"
          id="confirmationPage_createAnotherRequestButton"
          type="button"
          (click)="onCreateAnotherRequestClicked()"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >{{createAnotherTransactionButtonText}}</button>
        <button
          *ngIf="showSaveAsTemplate && !isInitiateAndReleaseFlowFromTable"
          id="confirmationPage_saveAsTemplate"
          data-testid="confirmationPage_saveAsTemplate"
          type="button"
          (click)="onSaveAsTemplateClicked()"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >Save this as a template</button>
      </div>
      <div
        *ngIf="isCondensedWireCreatePdfFlow"
        id="button-container"
        data-testid="wire-pdf-flow-buttons"
      >
        <button
          id="confirmationPage_createAnotherRequestButton"
          type="button"
          (click)="onCreateAnotherRequestClicked()"
          class="sdps-button sdps-button--small sdps-button--secondary"
        >{{createTransactionButtonText}}</button>
      </div>
    </div>
  </ng-template>
</div>